import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Skeleton } from '@chakra-ui/react';
import { ComboboxItem, ComboboxTagInput } from '@src/components/sco/ComboboxTagInput';
import { gql } from '@src/lib/gql';
import React, { useEffect, useState } from 'react';
export const InvestmentStageTagInput = props => {
  const $ = _c(33);
  let t0;
  if ($[0] !== props.defaultValue) {
    t0 = props.defaultValue || [];
    $[0] = props.defaultValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [investmentStages, setInvestmentStages] = useState(t0);
  let t1;
  if ($[2] !== investmentStages || $[3] !== props) {
    t1 = () => {
      props.onChange(investmentStages);
    };
    $[2] = investmentStages;
    $[3] = props;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== investmentStages) {
    t2 = JSON.stringify(investmentStages);
    $[5] = investmentStages;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = [t2];
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t1, t3);
  let t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = gql`
      {
        scoInvestorProfileSearchOptions {
          id
          allInvestmentStages
        }
      }
    `;
    t5 = {
      ssr: false
    };
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  const query = useQuery(t4, t5);
  let T0;
  let t10;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[11] !== props.defaultValue || $[12] !== query.data?.scoInvestorProfileSearchOptions?.allInvestmentStages || $[13] !== query.loading) {
    t10 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const allInvestmentStages = query.data?.scoInvestorProfileSearchOptions?.allInvestmentStages?.filter(Boolean) || [];
      if (query.loading) {
        let t11;
        if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
          t11 = <Skeleton borderRadius="0.25em" height="2.5em" width="full" css={{
            "--start-color": "blackAlpha.300",
            "--end-color": "blackAlpha.500"
          }} />;
          $[20] = t11;
        } else {
          t11 = $[20];
        }
        t10 = t11;
        break bb0;
      }
      T0 = ComboboxTagInput;
      t6 = true;
      let t11;
      if ($[21] !== props.defaultValue) {
        t11 = props.defaultValue || [];
        $[21] = props.defaultValue;
        $[22] = t11;
      } else {
        t11 = $[22];
      }
      if ($[23] !== t11) {
        t7 = t11.map(_temp);
        $[23] = t11;
        $[24] = t7;
      } else {
        t7 = $[24];
      }
      if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {};
        $[25] = t8;
      } else {
        t8 = $[25];
      }
      t9 = allInvestmentStages.map(_temp2);
    }
    $[11] = props.defaultValue;
    $[12] = query.data?.scoInvestorProfileSearchOptions?.allInvestmentStages;
    $[13] = query.loading;
    $[14] = T0;
    $[15] = t10;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[14];
    t10 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  if (t10 !== Symbol.for("react.early_return_sentinel")) {
    return t10;
  }
  let t11;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = values => {
      setInvestmentStages(values.map(_temp3));
    };
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== T0 || $[28] !== t6 || $[29] !== t7 || $[30] !== t8 || $[31] !== t9) {
    t12 = <T0 allowMultipleSelections={t6} defaultSelectedItems={t7} inputProps={t8} items={t9} onChange={t11} />;
    $[27] = T0;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};
function _temp(key) {
  return {
    key,
    title: key
  };
}
function _temp2(title) {
  return {
    key: title,
    title
  };
}
function _temp3(v) {
  return v.key;
}